export const sessionActionsTypes = {
  /** hold */
  HOLD: 'hold',
  /** unhold */
  UN_HOLD: 'unhold',
  /** mute */
  MUTE: 'mute',
  /** unmute */
  UN_MUTE: 'unmute',
  /** splitCallConference */
  SPLIT_CALL_CONFERENCE: 'splitCallConference',
  /** attendedtransfer */
  ATTENDED_TRANSFER: 'attendedtransfer',
  /** mergeCallConference */
  MERGE_CALL_CONFERENCE: 'mergeCallConference',
  /** transferOn */
  TRANSFER_ON: 'transferOn',
  /** transferOff */
  TRANSFER_OFF: 'transferOff',
  /** conferenceOn */
  CONFERENCE_ON: 'conferenceOn',
  /** conferenceOff */
  CONFERENCE_OFF: 'conferenceOff',
  /** announcementOn */
  ANNOUNCEMENT_ON: 'announcementOn',
  /** announcementOff */
  ANNOUNCEMENT_OFF: 'announcementOff',
  /** cancel */
  CANCEL: 'cancel',
  /** reject */
  REJECT: 'reject',
  /** finish */
  FINISH: 'finish',
  /** accept */
  ACCEPT: 'accept',
  /** dtmfAction - send dtmf codes */
  DTMF_ACTION: 'dtmfAction',
  /** tagsOff */
  TAGS_OFF: 'tagsOff',
  /** tagsOn */
  TAGS_ON: 'tagsOn',
  /** notesOff */
  NOTES_OFF: 'notesOff',
  /** notesOn */
  NOTES_ON: 'notesOn',
};
